@if(data){
    <div class="w-full md:w-10/12 mx-auto py-4">
        <form #usurioForm="ngForm">
            <mat-form-field
            class="w-full fuse-mat-dense">
            <mat-icon matPrefix
                class="hidden sm:flex icon-size-5"
                [svgIcon]="'heroicons_outline:user-circle'">
            </mat-icon>
            <input matInput type="text" id="nombre" [(ngModel)]="coleccionista.nombre" name="nombre" placeholder="Nombre" required/>
            </mat-form-field>
        
            <mat-form-field class="w-full fuse-mat-dense">
            <mat-icon matPrefix
                class="hidden sm:flex icon-size-5"
                [svgIcon]="'heroicons_outline:envelope'">
            </mat-icon>
            <input matInput type="email" id="email" name="email" [(ngModel)]="coleccionista.correoElectronico" placeholder="Email"/>
            </mat-form-field>

            <mat-form-field appearance="fill" class="w-full fuse-mat-dense">
                <mat-label>Número de Telefóno</mat-label>
                <mat-icon matPrefix
                    class="hidden sm:flex icon-size-5"
                    [svgIcon]="'heroicons_outline:phone'">
                </mat-icon>
                <input matInput type="tel" placeholder="Número de Telefóno" id="telefono" 
                name="telefono" 
                [(ngModel)]="coleccionista.telefono" 
                pattern="^[0-9]{8,}$"
                autocomplete="off"
                #numero="ngModel">

                <mat-error *ngIf="numero.errors?.pattern && numero.touched">
                    Debe contener al menos 8 dígitos numéricos.
                </mat-error>
            </mat-form-field> 

        </form>

        <div class="w-full flex justify-center gap-3 mt-3">
            <button mat-button mat-raised-button
            class=""  
            [color]="'secondary'" (click)="this.dialogRef.close(false);">
            Cancelar
            </button>

            <button mat-flat-button 
            [color]="'primary'" 
            type="submit"
            (click)="actualizarDatos()"
            [disabled]="!tieneCambios()">
            Actualizar
            </button>
        </div>
    </div>
}